import { Dictionary } from '../../../entities/common';
import { Layout, Section } from '../../../entities/Metadata';
import { SourceType } from '../../../store/ExternalEpmConnectStore';
import {
    sourceSettingsPropertyBySourceTypeMap, TASK_FORM_SETTINGS, TaskFormSettings
} from '../../common/sectionsControl/uiControls/scheduleControl/sourceSettings';

const SCHEDULE_SECTION_NAME = "Schedule";
const SCHEDULE_CONTROL_TYPE = "ScheduleControl";

export type ScheduleControlRef = { sectionId: string; uiControlId: string };

export type LayoutsLookup = { byId: Dictionary<Layout>; activeEntity?: Layout };

export function getEditedLayout(layouts: LayoutsLookup | undefined): Layout | undefined {
    const previewed = layouts?.activeEntity && layouts.byId[layouts.activeEntity.id];
    return previewed && !previewed.isView ? previewed : undefined;
}

export function getTaskFormSections(
    layouts: LayoutsLookup | undefined,
    entitySections: Section[] | undefined): Section[] | undefined {
    return getEditedLayout(layouts)?.sections ?? entitySections;
}

export function findScheduleControl(sections: Section[] | undefined): ScheduleControlRef | undefined {
    const section = sections?.find(_ => _.name === SCHEDULE_SECTION_NAME);
    const uiControl = section?.uiControls?.find(_ => _.type === SCHEDULE_CONTROL_TYPE);
    return section && uiControl ? { sectionId: section.id, uiControlId: uiControl.id } : undefined;
}

export function getTaskFormFields(sections: Section[] | undefined, sourceType: SourceType): string[] | undefined {
    const settings = sections
        ?.find(_ => _.name === SCHEDULE_SECTION_NAME)
        ?.uiControls?.find(_ => _.type === SCHEDULE_CONTROL_TYPE)
        ?.settings?.[TASK_FORM_SETTINGS] as TaskFormSettings | undefined;

    const sourceKey = sourceSettingsPropertyBySourceTypeMap[sourceType];
    return settings && sourceKey ? settings[sourceKey] : undefined;
}

export function buildTaskFormFields(defaultFields: string[], configuredFields: string[] | undefined): string[] {
    return configuredFields ?? defaultFields;
}
